import { useLabelRenameStore } from '@/modules/label-rename/store';

export function useLabels() {
    const labelRenameStore = useLabelRenameStore();
    labelRenameStore.ensureLoaded();

    const label = (defaultName, fallback = null) => {
        if (!defaultName) return fallback ?? '';
        const name = String(defaultName);
        return labelRenameStore.getLabel(name, fallback ?? name);
    };

    return { label };
}
